<template>
  <div>
    <v-data-table
        :options.sync="tableOptions"
:footer-props="footerProps"
        :no-data-text="$t('noData')"
        :no-results-text="$t('noResults')"
      item-key="name"
      :loading="loading"
      :loading-text="$t('loading_trips')"
      :headers="mode == 1 || mode == 3 ? translatedHeaders : translatedSuspendedHeaders"
      :items="trips"
      :search="debouncedSearch"
    >
      <template v-slot:top>
        <v-text-field
          v-model="search"
          :label="$t('search_trips')"
          class="mx-4"
        ></v-text-field>
      </template>

      <template
        v-if="mode == 1 || mode == 3"
        v-slot:item.first_stop_time="{ item }"
      >
        <small>{{ tConvert(item.first_stop_time) }}</small>
      </template>

      <template v-if="mode == 2" v-slot:item.trip.first_stop_time="{ item }">
        <small>{{ tConvert(item.trip.first_stop_time) }}</small>
      </template>

      <template v-slot:item.repetition_period="{ item }">
        <span v-if="item.repetition_period == 0">{{ $t('only_once') }}</span>
        <span v-else-if="item.repetition_period == 1">{{ $t('daily') }}</span>
        <span v-else>{{ $t('every_days', { count: item.repetition_period }) }}</span>
      </template>

      <template
        v-if="mode == 1 || mode == 3"
        v-slot:item.last_stop_time="{ item }"
      >
        <small>{{ tConvert(item.last_stop_time) }}</small>
      </template>

      <template v-if="mode == 2" v-slot:item.trip.last_stop_time="{ item }">
        <small>{{ tConvert(item.trip.last_stop_time) }}</small>
      </template>

      <template v-if="mode == 1 || mode == 3" v-slot:item.route.name="{ item }">
        <div v-if="item.route && item.route.name">
        <a @click.stop="displayRoute(item.route.id)">
            {{item.route.name}}
        </a>
        <v-chip dense
            :color="getTimeColor(item.route.is_morning)" dark>
                {{ item.route.is_morning ? $t('morning') : $t('afternoon') }}
        </v-chip>
        </div>
            <span v-else>{{ $t('no_route') }}</span>
      </template>

      <template v-if="mode == 2" v-slot:item.trip.route.name="{ item }">
        <div v-if="item.trip && item.trip.route && item.trip.route.name">
            <a @click.stop="displayRoute(item.trip.route.id)">{{ item.trip.route.name }}</a>
            <v-chip dense class="ml-2"
                :color="getTimeColor(item.trip.route.is_morning)" dark>
                    {{ item.trip.route.is_morning ? 'Morning' : 'Afternoon' }}
            </v-chip>
        </div>
            <span v-else>{{ $t('no_route') }}</span>
      </template>

      <template v-slot:item.driver="{ item }">
        <v-chip :color="getDriverAssignmentColor(item.driver)" dark @click="assignDriver(item)">
          {{ getTripDriver(item.driver) }}
        </v-chip>
      </template>

      <!-- how many children this trip carries. A trip with nobody on it is a
           bus running empty, and a trip over its seats is a child left at the
           kerb; neither was visible anywhere in this table. -->
      <template v-slot:item.students="{ item }">
        <v-chip
          small
          dark
          :color="seatColor(item)"
          @click="showStudents(item)"
        >
          {{ studentCount(item) }}<span v-if="seatsOf(item)"> / {{ seatsOf(item) }}</span>
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-menu offset-y
          right
          nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                v-on="on"
              >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(itm, index) in actionMenuItems()"
              :key="index"
              :value="index"
            >
            <div
            @click="doMenuAction(item, index)" class="d-flex align-center justify-start w-100">
              <v-list-item-icon>
                <v-icon>{{ itm.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="mx-2">{{ itm.title }}</v-list-item-title>
            </div>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.delay_report="{ item }">
        <v-chip v-if="item.delay_report" color='error' dark @click="viewDelayReport(item)">
          {{ item.delay_report.average_delay != 0 ? item.delay_report.average_delay + ' min' : 'No delay' }}
        </v-chip>
        <v-btn v-else :class="notEnoughHistoryForTimeLine(item) ? '' : 'error'"
         icon small @click="viewDelayReport(item)">
          <v-icon>mdi-clock-time-four-outline</v-icon>
        </v-btn>
      </template>
      <!-- <template v-slot:item.actions1="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-if="mode == 1" v-bind="attrs" v-on="on" small class="mx-2" @click="assignDriver(item)">
              mdi-account-tie-hat
            </v-icon>
          </template>
          <span>Assign driver</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small class="mx-2" @click="viewTrip(item)">
              mdi-eye
            </v-icon>
          </template>
          <span>View</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small class="mx-2" @click="viewTripCalendar(item)">
              mdi-calendar
            </v-icon>
          </template>
          <span>Calendar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-if="mode == 1"
              v-bind="attrs" v-on="on"
              small
              class="mr-2"
              @click="duplicateTrip(item)"
            >
              mdi-content-duplicate
            </v-icon>
          </template>
          <span>Duplicate</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs" v-on="on"
              small
              v-if="mode == 1 || mode == 3"
              @click="trashRestoreTrip(item, trips.indexOf(item))"
            >
              {{ item.status_id != 1 ? icons.mdiBackupRestore : icons.mdiTrashCan }}
            </v-icon>

            <v-icon
              v-bind="attrs" v-on="on"
              small
              v-if="mode == 2"
              @click="deleteSuspension(item, trips.indexOf(item))"
            >
              {{ icons.mdiBackupRestore }}
            </v-icon>
          </template>
          <span>{{item.status_id != 1 ? 'Restore' : 'Trash'}}</span>
        </v-tooltip>
      </template> -->
    </v-data-table>
    <students-on-dialog
      v-model="studentsDialog"
      scope="trip"
      :subject="studentsSubject"
    ></students-on-dialog>
    <v-dialog v-if="selectedTrip" v-model="dialog" max-width="390">
      <v-card>
        <!-- a trip whose route was deleted keeps running with no route, and
             reading the name off it threw as the dialog opened -->
        <div class="text-h5 pa-4"> {{ $t('select_driver_for_trip', { tripId: selectedTrip.id, routeName: selectedTrip.route ? selectedTrip.route.name : $t('no_route') }) }} </div>

        <v-card-text>
          <v-list dense>
            <v-subheader>{{ $t('drivers') }}</v-subheader>
            <v-list-item-group>
              <v-list-item
                v-for="(driver, i) in availableDrivers"
                :key="i"
              >
                    <v-list-item-content @click="assignDriverToTrip(driver)">
                      <div><strong>{{ driver.name }}</strong></div>
                      <div v-if="driver.buses && driver.buses.length" class="mt-1">
                        <v-chip
                          v-for="bus in driver.buses"
                          :key="bus.id"
                          class="me-1"
                          x-small
                          outlined
                          color="primary"
                        >
                          {{ bus.license }}
                        </v-chip>
                      </div>
                      <div v-if="driver.trip_intersect" class="error--text mt-1">
                          <p>Conflict with the trip {{ driver.trip_intersect.id }}<template v-if="driver.trip_intersect.route"> on route ({{ driver.trip_intersect.route.name }})</template><template v-if="driver.trip_intersect_date"> at {{ driver.trip_intersect_date | moment("LL") }}</template></p>
                            <!-- . <strong>Before selecting this driver, make sure that the driver is available on the planned time of the first stop of this trip.</strong> -->
                      </div>
                      <!-- a driver with several buses has to say which one
                           runs this trip -->
                      <div v-if="busChoiceDriver && busChoiceDriver.id === driver.id" class="mt-2">
                        <div class="text-caption">{{ $t('select_bus_for_trip') }}</div>
                        <v-chip
                          v-for="bus in driver.buses"
                          :key="'pick-' + bus.id"
                          class="me-1 mt-1"
                          small
                          color="primary"
                          dark
                          @click.stop="assignDriverToTrip(driver, bus)"
                        >
                          {{ bus.license }}
                        </v-chip>
                      </div>
                    </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-container style="height: 400px">
          <v-row
            v-show="loadingDrivers"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col class="text-subtitle-1 text-center" cols="12">
              {{ $t('loading_drivers') }}
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                :active="loadingDrivers"
                color="primary"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="
              dialog = false;
              loadingDrivers = false;
              availableDrivers = [];
              busChoiceDriver = null;
            "
          >
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog with trip time line -->
    <v-dialog v-if="selectedTripForTimeLine"
    v-model="timeLineDialog" max-width="400">
      <v-card>
        <v-card-title>
          <v-icon color="primary">
            mdi-clock-time-four-outline
          </v-icon>
          <span class="px-2">{{ $t('trip_timeline') }}</span>
        </v-card-title>
        <v-card-text v-if="notEnoughHistoryForTimeLine(selectedTripForTimeLine)">
          <!-- same as the driver dialog: the trip keeps running after its
               route is deleted, so the name may not be there to read -->
          <div class="text-h6 pa-4"> {{ $t('no_enough_history', { tripId: selectedTripForTimeLine.id, routeName: selectedTripForTimeLine.route ? selectedTripForTimeLine.route.name : $t('no_route') }) }} </div>
        </v-card-text>
        <v-card-text>
          <v-timeline align-top>
            <v-timeline-item
              v-for="(detail, index) in selectedTripForTimeLine.stopTimes"
              :key="detail.id"
            >
              <div class="pt-1">
                  <div><strong>{{ detail.stop_name }}</strong></div>
                  <div class="text-caption">
                    {{ detail.planned_time }}
                  </div>
                  <div v-if="detail.count != 0" class="error--text">
                    delay: {{ detail.avg_diff }} min
                  </div>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="timeLineDialog = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiStopCircleOutline,
  mdiPlayCircleOutline,
  mdiTrashCan,
  mdiDeleteRestore,
  mdiAirplane,
  mdiBackupRestore,
} from "@mdi/js";
import moment from 'moment';

import tableState from "@/mixins/tableState";
import StudentsOnDialog from "@/components/StudentsOnDialog";

export default {
  mixins: [tableState],
  props: {
    trips: Array,
    mode: Number,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: { StudentsOnDialog },
  data() {
    return {
      minMinutesForDelay: 5,
      studentCounts: {},
      studentsDialog: false,
      studentsSubject: null,
      isLoading: false,
      tableStateKey: "trips",
      loadingDrivers: false,
      availableDrivers: [],
      //the driver whose bus is being picked, when they hold more than one
      busChoiceDriver: null,
      dialog: false,
      selectedTrip: null,
      selectedTripForTimeLine: null,
      timeLineDialog: false,
      actionItemsActive: [
        {title: "edit", icon: 'mdi-pencil' }, // 'mdi-pencil'
        {title: "view", icon: 'mdi-eye' }, // 'mdi-eye'
        {title: "assign_driver", icon: 'mdi-account-tie-hat'}, // 'mdi-account-tie-hat'
        //un assign driver
        {title: "unassign_driver", icon: 'mdi-account-off' }, // 'mdi-account-off
        {title: "calendar", icon: 'mdi-calendar' }, // 'mdi-calendar'
        {title: "duplicate", icon: 'mdi-content-duplicate' }, // 'mdi-content-duplicate'
        {title: "trash", icon: 'mdi-trash-can' }, // 'mdi-trash-can'
      ],
      actionItemsSuspended: [
        {title: "view", icon: 'mdi-eye' }, // 'mdi-eye'
        {title: "calendar", icon: 'mdi-calendar' }, // 'mdi-calendar'
        {title: "restore", icon: 'mdi-backup-restore' }, // 'mdi-backup-restore'
      ],
      actionItemsTrashed: [
        {title: "view", icon: 'mdi-eye' }, // 'mdi-eye'
        {title: "Calendar", icon: 'mdi-calendar' }, // 'mdi-calendar'
        {title: "restore", icon: 'mdi-backup-restore' }, // 'mdi-backup-restore'
      ],
      headers: [
        { text: "ID", value: "id", align: "start"},
        { text: "Route", value: "route.name" },
        { text: "First stop", value: "first_stop_time" },
        { text: "Last stop", value: "last_stop_time" },
        { text: "Repeated", value: "repetition_period" },
        { text: "Effective", value: "effective_date" },
        { text: "Driver", value: "driver" },
        { text: "students", value: "students", sortable: false },
        { text: "Delay report", value: "delay_report" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      suspendedHeaders: [
        { text: "ID", value: "trip.id", align: "start"},
        { text: "Route", value: "trip.route.name" },
        { text: "First stop", value: "trip.first_stop_time" },
        { text: "Last stop", value: "trip.last_stop_time" },
        { text: "Suspension date", value: "date" },
        { text: "Suspension repetition", value: "repetition_period" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      icons: {
        mdiStopCircleOutline,
        mdiPlayCircleOutline,
        mdiTrashCan,
        mdiDeleteRestore,
        mdiAirplane,
        mdiBackupRestore,
      },
    };
  },
  computed: {
    translatedHeaders() {
      return this.headers.map(header => ({
        ...header,
        text: this.$t(header.text.toLowerCase().replace(' ', '_'))
      }));
    },
    translatedSuspendedHeaders() {
      return this.suspendedHeaders.map(header => ({
        ...header,
        text: this.$t(header.text.toLowerCase().replace(' ', '_'))
      }));
    },
    translatedActionItemsActive() {
      return this.actionItemsActive.map(item => ({
        ...item,
        title: this.$t(item.title)
      }));
    },
    translatedActionItemsSuspended() {
      return this.actionItemsSuspended.map(item => ({
        ...item,
        title: this.$t(item.title)
      }));
    },
    translatedActionItemsTrashed() {
      return this.actionItemsTrashed.map(item => ({
        ...item,
        title: this.$t(item.title)
      }));
    }
  },
  mounted() {
    this.loadStudentCounts();
  },
  methods: {
    //one request for the table rather than one per row; the counts come from
    //the student mapping, which is where a trip's passengers actually live
    loadStudentCounts() {
      axios
        .get("/school-students/assignments")
        .then((response) => {
          this.studentCounts = (response.data && response.data.trips) || {};
        })
        .catch(() => {
          //the rest of the table is still worth showing
        });
    },
    tripOf(item) {
      //the suspended tab nests the trip one level down
      return item.trip ? item.trip : item;
    },
    studentCount(item) {
      const trip = this.tripOf(item);
      return this.studentCounts[trip.id] || 0;
    },
    seatsOf(item) {
      const trip = this.tripOf(item);
      //the bus pinned to the trip wins; older trips fall back to the driver's
      if (trip.bus) return parseInt(trip.bus.capacity, 10);
      return trip.driver && trip.driver.bus ? parseInt(trip.driver.bus.capacity, 10) : null;
    },
    seatColor(item) {
      const count = this.studentCount(item);
      const seats = this.seatsOf(item);
      if (!count) return "warning";
      if (seats && count > seats) return "error";
      if (seats && count >= seats * 0.9) return "orange";
      return "primary";
    },
    showStudents(item) {
      this.studentsSubject = this.tripOf(item);
      this.studentsDialog = true;
    },
    notEnoughHistoryForTimeLine(trip)
    {
      if(trip && trip.stopTimes)
      {
        var keys = Object.keys(trip.stopTimes);
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if(trip.stopTimes[key].count == 0)
          {
            return true;
          }
        }
        return !this.isTripTimeNeedsAttention(trip);
      }
      return true;
    },
    isTripTimeNeedsAttention(trip)
    {
      if(trip && trip.stopTimes)
      {
        var keys = Object.keys(trip.stopTimes);
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if(trip.stopTimes[key].count != 0 && (trip.stopTimes[key].avg_diff > this.minMinutesForDelay || trip.stopTimes[key].avg_diff < -this.minMinutesForDelay))
          {
            return true;
          }
        }
        return false;
      }
      return false;
    },
    viewDelayReport(item)
    {
      this.selectedTripForTimeLine = item;
      this.timeLineDialog = true;
    },
    actionMenuItems()
    {
      if(this.mode == 1)
      {
        return this.translatedActionItemsActive;
      }
      else if(this.mode == 2)
      {
        return this.translatedActionItemsSuspended;
      }
      else if(this.mode == 3)
      {
        return this.translatedActionItemsTrashed;
      }
    },
    doMenuAction(item, index) {
      if(this.mode == 1)
      {
        if(index == 0)
        {
          this.editTrip(item);
        }
        else if(index == 1)
        {
          this.viewTrip(item);
        }
        else if(index == 2)
        {
          this.assignDriver(item);
        }
        else if(index == 3)
        {
          this.unAssignDriver(item);
        }
        else if(index == 4)
        {
          this.viewTripCalendar(item);
        }
        else if(index == 5)
        {
          this.duplicateTrip(item);
        }
        else if(index == 6)
        {
          this.trashRestoreTrip(item, this.trips.indexOf(item));
        }
      }
      else if(this.mode == 2)
      {
        if(index == 0)
        {
          this.viewTrip(item);
        }
        else if(index == 1)
        {
          this.viewTripCalendar(item);
        }
        else if(index == 2)
        {
          this.deleteSuspension(item, this.trips.indexOf(item));
        }
      }
      else if(this.mode == 3)
      {
        if(index == 0)
        {
          this.viewTrip(item);
        }
        else if(index == 1)
        {
          this.viewTripCalendar(item);
        }
        else if(index == 2)
        {
          this.trashRestoreTrip(item, this.trips.indexOf(item));
        }
      }
    },
    getDriverAssignmentColor(driver) {
      if (driver) return "success";
      else return "error";
    },
    getTripDriver(driver) {
      if (driver) return driver.name;
      else return this.$t("none");
    },
    tConvert(time) {
      if (time == null) {
        return null;
      }
      // Check correct time format and split into components
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)/) || [time];

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(""); // return adjusted time or original string
    },
    displayRoute(route_id) {
      this.$router.push({
        name: "view-route",
        params: { route_id: route_id },
      });
    },

    trashRestoreTrip(trip, index) {
      this.$emit("trashRestoreTrip", trip, index);
    },

    deleteSuspension(trip, index) {
      this.$emit("deleteSuspension", trip.id, index);
    },

    viewTripCalendar(item) {
      var trip_id = null;
      var suspension_id = "none";
      if (this.mode == 1 || this.mode == 3) {
        trip_id = item.id;
      } else {
        trip_id = item.trip.id;
        suspension_id = item.id;
      }
      this.$router.push({
        name: "view-calendar",
        params: { trip_id: trip_id, suspension_id: suspension_id },
      });
    },
    viewTrip(item) {
      var trip_id = null;
      if (this.mode == 1 || this.mode == 3) {
        trip_id = item.id;
      } else {
        trip_id = item.trip.id;
      }
      this.$router.push({
        name: "view-trip",
        params: { trip_id: trip_id },
      });
    },
    editTrip(trip) {
      this.$router.push({
        name: "edit-trip",
        params: { trip_id: trip.id, action: "edit" },
      });
    },
    assignDriver(item) {
      var trip_id = null;
      if (this.mode == 1 || this.mode == 3) {
        trip_id = item.id;
        this.selectedTrip = item;
      } else {
        trip_id = item.trip.id;
        this.selectedTrip = item.trip;
      }
      this.busChoiceDriver = null;
      this.dialog = true;
      this.loadAvailableDrivers()
    },
    unAssignDriver(item) {
        this.$swal({
            title: this.$t("warning"),
            text: this.$t("confirm_unassign_driver"),
            icon: "warning",
            buttons: true,
            dangerMode: true,
            showCancelButton: true,
            confirmButtonText: this.$t("yes_unassign"),
            cancelButtonText: this.$t("cancel"),
            }).then((result) => {
            if (result.isConfirmed) {
                this.unAssignDriverServer(item);
            }
        });
    },
    unAssignDriverServer(item)
    {
      this.isLoading = true;
      let idx = this.trips.findIndex((t) => t.id == item.id);
      axios
        .post(`/trips/unassign-driver`, {
          trip_id: item.id,
        })
        .then((response) => {
          this.$notify({
            title: this.$t("success_title"),
            text: this.$t("driver_unassigned"),
            type: "success",
          });
          this.trips[idx].driver = null;
          //the bus leaves with the driver
          this.$set(this.trips[idx], 'bus', null);
        })
        .catch((error) => {
          this.$notifyError(error, this.$t("error_unassigning_driver"));
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    loadAvailableDrivers() {
      this.loadingDrivers = true;
      let params = {
        trip_id: this.selectedTrip.id,
      };
      axios
        .get(`/drivers/available`, { params: params })
        .then((response) => {
          this.availableDrivers = response.data.availableDrivers;
        })
        .catch((error) => {
          this.$notify({
            title: this.$t("error_title"),
            text: this.$t("error_retrieving_drivers"),
            type: "error",
          });
          console.log(error);
          this.loadingDrivers = false;
          this.$notifyError(error);
        })
        .then(() => {
          this.loadingDrivers = false;
        });
    },
    duplicateTrip(trip) {
      this.$router.push({
        name: "edit-trip",
        params: {
          trip_id: trip.id,
          action: "duplicate",
        },
      });
    },
    assignDriverToTripServer(driver, bus)
    {
      this.isLoading = true;
      let idx = this.trips.findIndex((t) => t.id == this.selectedTrip.id);
      axios
        .post(`/trips/assign-driver`, {
          trip_id: this.selectedTrip.id,
          driver_id: driver.id,
          bus_id: bus ? bus.id : null,
        })
        .then((response) => {
          this.$notify({
            title: this.$t("success_title"),
            text: this.$t("driver_assigned"),
            type: "success",
          });
          this.trips[idx].driver = response.data.driver;
          //the bus that runs the trip, for the seats column
          this.$set(this.trips[idx], 'bus', bus || (driver.buses && driver.buses.length ? driver.buses[0] : null));
          this.onAssignedFinished();
        })
        .catch((error) => {
          this.$notify({
            title: this.$t("error_title"),
            text: this.$t("error_assigning_driver"),
            type: "error",
          });
          console.log(error);
          this.onAssignedFinished();
          this.$notifyError(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    assignDriverToTrip(driver, bus = null) {
      //a driver holding several buses has to say which one runs the trip
      if (!bus && driver.buses && driver.buses.length > 1) {
        this.busChoiceDriver = driver;
        return;
      }
      const chosenBus = bus || (driver.buses && driver.buses.length ? driver.buses[0] : null);
      if(driver.trip_intersect)
      {
        this.$swal({
          title: this.$t("warning"),
          html: this.$t("confirm_assign_driver", { tripId: driver.trip_intersect.id, routeName: driver.trip_intersect.route.name, date: moment(driver.trip_intersect_date).format('LL') }),
          icon: "warning",
          buttons: true,
          dangerMode: true,
          showCancelButton: true,
          confirmButtonText: this.$t("yes_assign"),
          cancelButtonText: this.$t("cancel"),
        }).then((result) => {
          if (result.isConfirmed) {
            this.assignDriverToTripServer(driver, chosenBus);
          }
        });
      }
      else
      {
        this.assignDriverToTripServer(driver, chosenBus);
      }
    },
    onAssignedFinished()
    {
      this.dialog = false;
      this.busChoiceDriver = null;
    },
    getTimeColor(is_morning) {
      return is_morning ? "success" : "warning";
    },
  },
};
</script>
<style lang="scss">
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover{
  cursor: pointer;
  background: rgba($primary-shade--light, 0.15) !important;
}
</style>
